// src/pages/Moderation/ChannelsViolationsPage/ui/ChannelsViolationsTable/ChannelsViolationsHeader.tsx
import React from 'react';

export const ChannelsViolationsHeader: React.FC = () => {
  return (
    <div className="cv-table__header">
      <div className="cv-table__cell">Channel</div>
      <div className="cv-table__cell">Link</div>
      <div className="cv-table__cell">ID</div>
      <div className="cv-table__cell">Restrictions</div>
      <div className="cv-table__cell">Created</div>
      <div className="cv-table__cell">Action</div>
    </div>
  );
};
